<template>
	<div>
		<OverviewAlignmentCard
			:score="comparisonMatchScore"
			:side="side"
			:summary="(verdict && verdict.summary) || ''"
			class="mb-10"
		/>

		<div class="grid grid-cols-1 lg:grid-cols-2 gap-x-10">
			<AiVerdictInsights
				v-if="hasVerdict"
				:why-fit="verdict.why_fit || []"
				:what-to-watch="verdict.what_to_watch || []"
				:side="side"
				class="order-2 mt-6 lg:mt-0 lg:order-1"
				@insight-opened="$emit('insight-opened', $event)"
			/>

			<section
				class="mb-6 lg:mb-0"
				:class="hasVerdict ? 'order-1 lg:order-2' : ''"
			>
				<PersonalityWheel
					:results="applicantWheelResults"
					:applicant-results="applicantWheelResults"
					:job-offer-results="jobOfferWheelResults"
					mode="comparison"
					class="max-w-[450px] mx-auto px-5"
					animated
				/>

				<div class="flex justify-center">
					<ComparisonLegend />
				</div>

				<OverviewPanelComparison
					v-if="hasVerdict"
					:job-offer-data="jobOfferData"
					:applicant-data="applicantData"
					:match-data="matchData"
					wheel-mode="comparison"
					class="hidden mt-6"
				/>
			</section>

			<OverviewPanelComparison
				v-if="!hasVerdict"
				:job-offer-data="jobOfferData"
				:applicant-data="applicantData"
				:match-data="matchData"
				wheel-mode="comparison"
			/>
		</div>
	</div>
</template>

<script>
import personalityResults from '~/mixins/personalityResults'
import PersonalityWheel from '~/components/Personality/PersonalityWheel'
import AiVerdictInsights from './AiVerdictInsights.vue'
import ComparisonLegend from './ComparisonLegend.vue'
import OverviewAlignmentCard from './OverviewAlignmentCard.vue'
import OverviewPanelComparison from './OverviewPanelComparison.vue'

export default {
	name: 'OverviewComparisonContent',
	components: {
		AiVerdictInsights,
		ComparisonLegend,
		OverviewAlignmentCard,
		OverviewPanelComparison,
		PersonalityWheel
	},
	mixins: [personalityResults],
	props: {
		jobOfferData: {
			type: Object,
			default: () => ({})
		},
		applicantData: {
			type: Object,
			default: () => ({})
		},
		matchData: {
			type: Object,
			default: null
		},
		verdict: {
			type: Object,
			default: null
		},
		side: {
			type: String,
			default: 'company',
			validator: value => ['company', 'applicant'].includes(value)
		}
	},
	computed: {
		hasVerdict() {
			return (
				(this.verdict?.why_fit?.length ?? 0) > 0 ||
				(this.verdict?.what_to_watch?.length ?? 0) > 0
			)
		},
		applicantWheelResults() {
			return this.buildPersonalityObject(this.applicantData)
		},
		jobOfferWheelResults() {
			return this.buildPersonalityObject(this.jobOfferData)
		}
	}
}
</script>
